import React from 'react'
import { PORTAL } from 'types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { ContentBlock, FormBlock, PortalSupport } from 'components'
import { Link } from 'react-router'
import { SIGN_IN_ROUTE } from 'config'
import { useCommunity } from 'utils'
import { TimerIcon } from 'components/icons/basic'

const propTypes = {}

function AccountPendingConfirmation() {
  const community = useCommunity()
  return (
    <ContentBlock>
      <FormBlock>
        <div className="account-pending-confirmation text-center">
          <TimerIcon />
          <div className="account-confirmation-content">
            <h1>Your account is pending confirmation</h1>
            <p>
              A community admin is currently reviewing your account and will
              reach out soon.
            </p>
            <p>
              In the meantime, please check your email for a message with
              instructions to claim your account and log in.
            </p>
          </div>
          <div>
            <Link className="button-primary" to={SIGN_IN_ROUTE}>
              Back to Log In
            </Link>
          </div>
        </div>
      </FormBlock>
      <PortalSupport
        supportEmail={community.partnerSupportEmail}
        portalType={PORTAL.PARTNER_PORTAL}
      />
    </ContentBlock>
  )
}

AccountPendingConfirmation.propTypes = propTypes

function mapStateToProps() {
  return {}
}

const mapDispatchToProps = {}

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  AccountPendingConfirmation
)
